import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { useScopedPath } from "@/lib/scoped";
import { XCircle } from "lucide-react";

export default function PaymentsCancelPage() {
  const scope = useScopedPath();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-24" data-testid="payment-cancel-page">
        <div className="border border-zinc-200 rounded-sm bg-white p-10 text-center">
          <XCircle className="mx-auto h-12 w-12 text-zinc-500" aria-hidden="true" />
          <h1 className="font-heading text-3xl font-bold tracking-tight text-zinc-950 mt-6">Payment cancelled.</h1>
          <p className="mt-3 text-sm text-zinc-600">You haven&apos;t been charged. You can try again any time before kickoff.</p>
          <div className="mt-8 flex justify-center gap-3">
            <button
              type="button"
              onClick={() => navigate(scope("/"), { replace: true })}
              data-testid="payment-cancel-back-home"
              className="h-10 px-5 rounded-sm bg-zinc-950 hover:bg-zinc-800 text-white font-semibold text-sm"
            >
              Back to predictions
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
